module.exports = __webpack_public_path__ + "media/images/design/images/vol_search/btn_vol02-179442d916c740075442184d2fa8a8ee.png";